import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, FormSection, SubmissionError, change, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import classNames from 'classnames';
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import ReactQuill from 'react-quill';
import ArtistLoginForm from '../../components/ArtistLoginForm';
import ReactDragListView from 'react-drag-listview/lib/index.js';
import Nestable from 'react-nestable';
import agent from '../../agent'
import _range from 'lodash/range'
import _debounce from 'lodash/debounce'
import { history } from '../../store/configureStore'
import AMLogo from '../../assets/images/audition-magic-favicon.png';
import CloseButton from '../../assets/images/close-dark.png';
import skillsOption from '../../data/skills';
import Aux from '../../containers/AuxContainer'

const ActivateField = ({ input, className, id, label, type, meta: { touched, error, warning } }) => {
  const fix = {
    marginLeft: '1rem'
  }
  return (
    <Aux>
    <div className="switch radius tiny float-left">
      <input 
        {...input}
        className="switch-input" 
        id="checkin-enabled" 
        type={type} />
      <label style={fix} className="switch-paddle" htmlFor="checkin-enabled">
        <span className="show-for-sr">{label}</span>
      </label>
    </div>
    <label style={fix} htmlFor="checkin-enabled" className="float-left switch-label">{label}</label>
    </Aux>
  )
}

class SkillForm extends Component {
  state = {
    sportsActive: 'accordion-content accordion-active',
    sportsSelected: 'accordion-title sport-selected acc-title',
    danceActive: 'accordion-content',
    danceSelected: 'accordion-title acc-title',
    voiceActive: 'accordion-content',
    voiceSelected: 'accordion-title acc-title',
    instrumentActive: 'accordion-content',
    instrumentSelected: 'accordion-title acc-title',
    accentsActive: 'accordion-content',
    accentsSelected: 'accordion-title acc-title',
    languagesActive: 'accordion-content',
    languagesSelected: 'accordion-title acc-title',
    circusActive: 'accordion-content',
    circusSelected: 'accordion-title acc-title',
    performanceActive: 'accordion-content',
    performanceSelected: 'accordion-title acc-title',
    othersActive: 'accordion-content',
    othersSelected: 'accordion-title acc-title',
    
    sports: [],
    dance: [],
    voice: [],
    instrument: [],
    accents: [],
    languages: [],
    circus: [],
    performance: [],
    others: [],

    skillsDict: {}
  }

  componentWillMount() {
    const { skills } = this.props

    let skillsDict = {}
    
    if (skills) {
      try {
        var arrSkills = JSON.parse(skills)
        arrSkills.map((item, i) => {
          let objHolder = []

          let sortedItem = item.sort((a, b) => (a[0] == b[0]) ? a[1].localeCompare(b[1]) : b[2] - a[2])

          sortedItem.map((item2, j) => {

            if (skillsDict[item2[0]] == null)
              skillsDict[item2[0]] = {}

            if (skillsDict[item2[0]][item2[1]] == null ){
              skillsDict[item2[0]][item2[1]] = true
              objHolder = [ ...objHolder, { name: item2[1], level: item2[2], media: item2[3] } ]
              this.setState({ [`${item2[0]}`] : objHolder });
            }
          })
        });
      } catch (e) {
        return
      }
    }
    this.setState({skillsDict: skillsDict});
    console.log('componentWillMount-skills', skills, this.props, this.state.sports)
  }

  componentWillReceiveProps (nextProps) {
    
  }

  componentDidUpdate(prevProps) {
    const skillTree = {
      sports: this.state.sports, 
      dance: this.state.dance,
      voice: this.state.voice,
      instrument: this.state.instrument,
      accents: this.state.accents,
      languages: this.state.languages,
      circus: this.state.circus,
      performance: this.state.performance,
      others: this.state.others
    }
    console.log('componentDidUpdate', skillTree)
    window.localStorage.setItem('global_artist_skills', JSON.stringify(skillTree));
  }

  submit = (values, dispatch, props) => {
    
  }

  accordion_select = (value) => {
    this.setState({
      sportsActive: value === 'sports' ? 'accordion-content accordion-active' : 'accordion-content',
      sportsSelected: value === 'sports' ? 'accordion-title sport-selected acc-title' : 'accordion-title acc-title',
      danceActive: value === 'dance' ? 'accordion-content accordion-active' : 'accordion-content',
      danceSelected: value === 'dance' ? 'accordion-title dance-selected acc-title' : 'accordion-title acc-title',
      voiceActive: value === 'voice' ? 'accordion-content accordion-active' : 'accordion-content',
      voiceSelected: value === 'voice' ? 'accordion-title voice-selected acc-title' : 'accordion-title acc-title',
      instrumentActive: value === 'instrument' ? 'accordion-content accordion-active' : 'accordion-content',
      instrumentSelected: value === 'instrument' ? 'accordion-title instrument-selected acc-title' : 'accordion-title acc-title',
      accentsActive: value === 'accents' ? 'accordion-content accordion-active' : 'accordion-content',
      accentsSelected: value === 'accents' ? 'accordion-title accents-selected acc-title' : 'accordion-title acc-title',
      languagesActive: value === 'languages' ? 'accordion-content accordion-active' : 'accordion-content',
      languagesSelected: value === 'languages' ? 'accordion-title languages-selected acc-title' : 'accordion-title acc-title',
      circusActive: value === 'circus' ? 'accordion-content accordion-active' : 'accordion-content',
      circusSelected: value === 'circus' ? 'accordion-title circus-selected acc-title' : 'accordion-title acc-title',
      performanceActive: value === 'performance' ? 'accordion-content accordion-active' : 'accordion-content',
      performanceSelected: value === 'performance' ? 'accordion-title performance-selected acc-title' : 'accordion-title acc-title',
      othersActive: value === 'others' ? 'accordion-content accordion-active' : 'accordion-content',
      othersSelected: value === 'others' ? 'accordion-title others-selected acc-title' : 'accordion-title acc-title'
    })
  }

  setSkills = (category, value) => {
    if (this.state.skillsDict[category] != null && this.state.skillsDict[category][value] != null) {
      let skillsDict = this.state.skillsDict
      delete skillsDict[category][value];
      // Don't forget to remove the selection as well
      let currCatval = this.state[category].filter(item => item.name != value)
      this.setState({[category]: currCatval, skillsDict: skillsDict})
    } else {
      let skillsDict = this.state.skillsDict
      if (skillsDict[category] == null) skillsDict[category] = {}
      if (skillsDict[category][value] == null) skillsDict[category][value] = true
      this.setState({ [category] : [...this.state[category], { name: value, level: 0, media: [] } ], skillsDict: skillsDict });  
    }
  }

  setSkillLevel = (value, category, name) => {

    this.setState({ [category]: this.state[category].map(
      (k, i) => {
        if (k.name === name) {
          k.level = value
        }
        return k
      })
    })
  }

  addOtherSkills = (value) => {
    console.log('addOtherSkills', this.state.tempOtherSkill)
    this.setState({
      others: [ ...this.state.others, { name: this.state.tempOtherSkill, level: 0, media: [] } ],
      tempOtherSkill: ''
    })
  }

  setTempOtherSkill = value => {
    console.log('setTempOtherSkill', value)
    this.setState({
      tempOtherSkill: value
    })
  }

  render() {
    const { handleSubmit, submitting, pristine, artistType, initialValues, disableButton } = this.props
    const headerText = {
      color: '#fff',
      textAlign: 'center'
    }
    const rowPaddingBottom = {
      paddingBottom: '3rem'
    }
    const tableFix = {
      tableLayout: 'fixed'
    }
    const headerFix = {
      textAlign: 'center',
      fontSize: '1.25rem'
    }
    const starFix = {
      paddingLeft: '4rem',
      paddingRight: '4rem'
    }
    const paddingFix1 = {
      paddingLeft: '4rem'
    }
    const paddingFix2 = {
      paddingLeft: '2rem'
    }
    const skillLevel = [ { slevel: 'Expert', level: 5, star: 'star5' },
      { slevel: 'Very Good', level: 4, star: 'star4' },
      { slevel: 'Good', level: 3, star: 'star3' },
      { slevel: 'Average', level: 2, star: 'star2' },
      { slevel: 'Basic', level: 1, star: 'star1' }, ]

    console.log('render-skill', this.state.dance)
    return (
      <div>
        <section id="skill-profile" className="section gray-bg">
          { /*<div className="row">
            <div className="column medium-2 align-right">
              <Field 
                type="checkbox"
                name="activated_enabled"
                component={ActivateField}
                label="Activate" />
            </div>
          </div>*/ }
          <div style={rowPaddingBottom} className="row">
            <div className="column">
              <p style={headerText}>Select your 20 best skills, then scroll below to set your level of each skill selected</p>
            </div>
          </div>
          <div className="row">
            <div className="column medium-12">
              <ul className="accordion" data-accordion>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("sports")} data-content="sports-panel" className={this.state.sportsSelected}>Sports</a>
                  <div id="sports-panel" className={this.state.sportsActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Sports').values.map((item, i) => {
                        let id=`sports-${item.value}`
                        let checkVal = this.state.skillsDict.sports != null && this.state.skillsDict.sports[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('sports', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.label}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("dance")} data-content="dance-panel" className={this.state.danceSelected}>Dance</a>
                  <div id="dance-panel" className={this.state.danceActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Dance').values.map((item, i) => {
                        let id=`dance-${item.value}`
                        let checkVal = this.state.skillsDict.dance != null && this.state.skillsDict.dance[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('dance', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("voice")} data-content="voice-panel" className={this.state.voiceSelected}>Voice</a>
                  <div id="voice-panel" className={this.state.voiceActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Voice').values.map((item, i) => {
                        let id=`voice-${item.value}`
                        let checkVal = this.state.skillsDict.voice != null && this.state.skillsDict.voice[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('voice', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("instrument")} data-content="instrument-panel" className={this.state.instrumentSelected}>Instrumental</a>
                  <div id="instrument-panel" className={this.state.instrumentActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Instrumental').values.map((item, i) => {
                        let id=`instrument-${item.value}`
                        let checkVal = this.state.skillsDict.instrument != null && this.state.skillsDict.instrument[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('instrument', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("accents")} data-content="accents-panel" className={this.state.accentsSelected}>Accents</a>
                  <div id="accents-panel" className={this.state.accentsActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Accents').values.map((item, i) => {
                        let id=`accents-${item.value}`
                        let checkVal = this.state.skillsDict.accents != null && this.state.skillsDict.accents[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('accents', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("languages")} data-content="languages-panel" className={this.state.languagesSelected}>Languages</a>
                  <div id="languages-panel" className={this.state.languagesActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Languages').values.map((item, i) => {
                        let id=`languages-${item.value}`
                        let checkVal = this.state.skillsDict.languages != null && this.state.skillsDict.languages[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('languages', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("circus")} data-content="circus-panel" className={this.state.circusSelected}>Circus</a>
                  <div id="circus-panel" className={this.state.circusActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Circus').values.map((item, i) => {
                        let id=`circus-${item.value}`
                        let checkVal = this.state.skillsDict.circus != null && this.state.skillsDict.circus[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('circus', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("performance")} data-content="performance-panel" className={this.state.performanceSelected}>Performance</a>
                  <div id="performance-panel" className={this.state.performanceActive}>
                    <div className="row">
                    {
                      skillsOption.find(k => k.label === 'Performance').values.map((item, i) => {
                        let id=`performance-${item.value}`
                        let checkVal = this.state.skillsDict.performance != null && this.state.skillsDict.performance[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('performance', item.value)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.value}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
                <li className="accordion-item acc-active-border">
                  <a onClick={e => this.accordion_select("others")} data-content="others-panel" className={this.state.othersSelected}>Others</a>
                  <div id="others-panel" className={this.state.othersActive}>
                    <div className="grid-x align-middle">
                      <div style={paddingFix1} className="cell medium-6">
                        <div className="registartion-profile-form registration-fix-form" id="reg-profile-form">
                          <input name="others.skills" type="text" label="Type your suggested skill" value={this.state.tempOtherSkill}
                            onChange={e => this.setTempOtherSkill(e.target.value)} />
                        </div>
                      </div>
                      <div style={paddingFix2} className="cell medium-6">
                        <a onClick={e => this.addOtherSkills(e.target.value)} className="fa fa-plus fa-fix" aria-hidden="true"></a>
                      </div>
                    </div>
                    <div className="row">
                    {
                      this.state.others.map((item, i) => {
                        let id=`others-${item.name}`
                        let checkVal = this.state.skillsDict.others != null && this.state.skillsDict.others[item.value] != null
                        return (<div key={i} className="column medium-4 checkbox-wrapper"><div className="custom-checkbox">
                                <Field
                                  className="styled-checkbox"
                                  name={id}
                                  id={id}
                                  component="input"
                                  checked={checkVal}
                                  onChange={e => this.setSkills('others', item.name)}
                                  type="checkbox"
                                />
                                <label className="skill-text-color" htmlFor={id}>{item.name}</label>
                              </div></div>)
                      })
                    }
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section id="skill-level-profile" className="section gray-bg">
          {
            (this.state.sports.length >= 1 ||
            this.state.dance.length >= 1 ||
            this.state.voice.length >= 1 ||
            this.state.instrument.length >= 1 ||
            this.state.accents.length >= 1 ||
            this.state.languages.length >= 1 ||
            this.state.circus.length >= 1 ||
            this.state.performance.length >= 1 ||
            this.state.others.length >= 1) &&
            (<div style={rowPaddingBottom} className="row">
              <div className="column">
                <p style={headerText}>Apply the level of your selected skills.</p>
              </div>
            </div>)
          }
          <div className="row">
            <div className="column medium-12">
              { /*** Sports ***/ }
              {
                this.state.sports.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Sports</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.sports.map((item, i) => {
                        let id1=`sports.${item.name}.star1`
                        let id2=`sports.${item.name}.star2`
                        let id3=`sports.${item.name}.star3`
                        let id4=`sports.${item.name}.star4`
                        let id5=`sports.${item.name}.star5`
                        let name=`sports.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'sports', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'sports', item.name)}/>
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'sports', item.name)}/>
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'sports', item.name)}/>
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'sports', item.name)}/>
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Dance ***/ }
              {
                this.state.dance.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Dance</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.dance.map((item, i) => {
                        let id1=`dance.${item.name}.star1`
                        let id2=`dance.${item.name}.star2`
                        let id3=`dance.${item.name}.star3`
                        let id4=`dance.${item.name}.star4`
                        let id5=`dance.${item.name}.star5`
                        let name=`dance.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'dance', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'dance', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'dance', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'dance', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'dance', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Voice ***/ }
              {
                this.state.voice.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Voice</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.voice.map((item, i) => {
                        let id1=`voice.${item.name}.star1`
                        let id2=`voice.${item.name}.star2`
                        let id3=`voice.${item.name}.star3`
                        let id4=`voice.${item.name}.star4`
                        let id5=`voice.${item.name}.star5`
                        let name=`voice.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'voice', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'voice', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'voice', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'voice', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'voice', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Instrumental ***/ }
              {
                this.state.instrument.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Instrumental</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.instrument.map((item, i) => {
                        let id1=`instrument.${item.name}.star1`
                        let id2=`instrument.${item.name}.star2`
                        let id3=`instrument.${item.name}.star3`
                        let id4=`instrument.${item.name}.star4`
                        let id5=`instrument.${item.name}.star5`
                        let name=`instrument.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'instrument', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'instrument', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'instrument', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'instrument', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'instrument', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Accents ***/ }
              {
                this.state.accents.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Accents</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.accents.map((item, i) => {
                        let id1=`accents.${item.name}.star1`
                        let id2=`accents.${item.name}.star2`
                        let id3=`accents.${item.name}.star3`
                        let id4=`accents.${item.name}.star4`
                        let id5=`accents.${item.name}.star5`
                        let name=`accents.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'accents', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'accents', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'accents', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'accents', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'accents', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Languages ***/ }
              {
                this.state.languages.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Languages</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.languages.map((item, i) => {
                        let id1=`languages.${item.name}.star1`
                        let id2=`languages.${item.name}.star2`
                        let id3=`languages.${item.name}.star3`
                        let id4=`languages.${item.name}.star4`
                        let id5=`languages.${item.name}.star5`
                        let name=`languages.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'languages', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                onChange={e => this.setSkillLevel(e.target.value, 'languages', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'languages', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'languages', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'languages', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Circus ***/ }
              {
                this.state.circus.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Circus</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.circus.map((item, i) => {
                        let id1=`circus.${item.name}.star1`
                        let id2=`circus.${item.name}.star2`
                        let id3=`circus.${item.name}.star3`
                        let id4=`circus.${item.name}.star4`
                        let id5=`circus.${item.name}.star5`
                        let name=`circus.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'circus', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'circus', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'circus', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'circus', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'circus', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Performance ***/ }
              {
                this.state.performance.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Performance</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.performance.map((item, i) => {
                        let id1=`performance.${item.name}.star1`
                        let id2=`performance.${item.name}.star2`
                        let id3=`performance.${item.name}.star3`
                        let id4=`performance.${item.name}.star4`
                        let id5=`performance.${item.name}.star5`
                        let name=`performance.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'performance', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'performance', item.name)} />
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'performance', item.name)} />
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'performance', item.name)} />
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'performance', item.name)} />
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
              { /*** Others ***/ }
              {
                this.state.others.length >= 1 &&
                (<table style={tableFix}>
                  <thead>
                    <tr className="header">
                      <th style={headerFix}>Others</th>
                      <th style={headerFix}>Skill Level</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.others.map((item, i) => {
                        let id1=`others.${item.name}.star1`
                        let id2=`others.${item.name}.star2`
                        let id3=`others.${item.name}.star3`
                        let id4=`others.${item.name}.star4`
                        let id5=`others.${item.name}.star5`
                        let name=`others.${item.name}.rating`
                        return (
                          <tr key={i}>
                            <td className="skill-name">{item.name}</td>
                            <td className="star">
                              <fieldset className="rating">
                                <input type="radio" id={id5} name={name} value="5" checked={item.level == 5}
                                  onChange={e => this.setSkillLevel(e.target.value, 'others', item.name)} />
                                <label className = "full" htmlFor={id5} title="Expert"><span className="star-label">5</span></label>
                                <input type="radio" id={id4} name={name} value="4" checked={item.level == 4}
                                  onChange={e => this.setSkillLevel(e.target.value, 'others', item.name)}/>
                                <label className = "full" htmlFor={id4} title="Very Good"><span className="star-label">4</span></label>
                                <input type="radio" id={id3} name={name} value="3" checked={item.level == 3}
                                  onChange={e => this.setSkillLevel(e.target.value, 'others', item.name)}/>
                                <label className = "full" htmlFor={id3} title="Good"><span className="star-label">3</span></label>
                                <input type="radio" id={id2} name={name} value="2" checked={item.level == 2}
                                  onChange={e => this.setSkillLevel(e.target.value, 'others', item.name)}/>
                                <label className = "full" htmlFor={id2} title="Average"><span className="star-label">2</span></label>
                                <input type="radio" id={id1} name={name} value="1" checked={item.level == 1}
                                  onChange={e => this.setSkillLevel(e.target.value, 'others', item.name)}/>
                                <label className = "full" htmlFor={id1} title="Basic"><span className="star-label">1</span></label>
                              </fieldset>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>)
              }
            </div>
          </div>
        </section>

        <form onSubmit={handleSubmit} className="registartion-profile-form registration-fix-form" id="reg-profile-form">
          <FormSection name="artist">
          </FormSection>
          <section className="section">
            <div className="grid-x align-center">
              <div className="small-12 cell text-center">
                <button className="button primary" 
                  type="submit">
                    {submitting || disableButton ? 'Saving...' : 'Save' }
                </button>
              </div>
            </div>
          </section>
        </form>
      </div>
      )
  }
}

SkillForm = reduxForm({
  form: 'artistProfile', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  // asyncValidate,
  // asyncBlurFields: ['first_name', 'last_name', 'email']
})(SkillForm)

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(SkillForm);


// WEBPACK FOOTER //
// ./src/components/profile/SkillForm.js